import React, { useState } from 'react';
import BaseDialog from '../BaseDialog';
import RoundResultTable from '../../result/RoundResultTable';
import { Box, Typography, LinearProgress } from '@mui/material';

const ROUND_NOT_FORMED_DESCRIPTION = {
  no_bets: 'このラウンドにはベットが入らなかったため、不成立となりました。',
  one_sided_bets: 'ベットが一方の選択肢に集中したため、成立に必要なベットが集まりませんでした。ベットしたルームチップは返還されています。',
  result_dispute_unresolved: '結果について判断が一致しなかったため、このラウンドは不成立になりました。ベットは全額返却されます。',
};

const getRoundNotFormedDescription = (reason) => (
  ROUND_NOT_FORMED_DESCRIPTION[reason] ?? ROUND_NOT_FORMED_DESCRIPTION.one_sided_bets
);

const OwnerResultDialog = ({ isVisible, onClose, dialogDatas, dialogMode, containerRef }) => {
  const [view, setView] = useState('result'); // 'table' or 'result'

  const renderResult = () => {
    if (!dialogDatas || !dialogDatas.result) {
      return <p>No result data available.</p>;
    }

    const result = dialogDatas.result;

    if (result.round_not_formed) {
      const description = getRoundNotFormedDescription(result.round_not_formed_reason);

      return (
        <Box sx={{ p: 3, minWidth: 300, textAlign: 'center' }} data-round-not-formed="true">
          <Typography variant="h6" gutterBottom>このラウンドは不成立となりました</Typography>
          <Typography color="text.secondary">
            {description}
          </Typography>
        </Box>
      );
    }

    const answers = dialogDatas.result.answers;
    const topResult = result.all?.topResult?.[0];
    const totalBet = result.all?.totalBet ?? 0;
    const betBySelection = result.all?.betBySelection || [];

    return (
      <Box sx={{ p: 2, minWidth: 300 }}>
        <Typography variant="h6" gutterBottom>ラウンド概要</Typography>
        <Typography variant="body1">参加者数: {result.all?.participantsCount ?? '-'} 人</Typography>
        <Typography variant="body1">総ベット額: {totalBet} pt</Typography>
        {topResult && (
          <Typography variant="body1">最高配当者: {topResult.name}（{topResult.totalRefund} pt）</Typography>
        )}

        <hr style={{ margin: '16px 0' }} />

        <Typography variant="h6" gutterBottom>選択肢ごとのベット分布</Typography>
        {betBySelection.length > 0 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {betBySelection.map((bet, idx) => {
              const percentage = totalBet > 0 ? (bet.totalBet / totalBet) * 100 : 0;
              return (
                <Box key={idx}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                    <Typography variant="body1">
                      {answers[bet.selection] || `選択肢 ${bet.selection}`}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {bet.totalBet} pt ({percentage.toFixed(1)}%)
                    </Typography>
                  </Box>
                  <LinearProgress variant="determinate" value={percentage} sx={{ height: 8, borderRadius: 4 }}/>
                </Box>
              );
            })}
          </Box>
        ) : (
          <Typography>ベットデータがありません</Typography>
        )}
      </Box>
    );
  };

  return (
    <div>
      <BaseDialog isVisible={isVisible} onClose={onClose} dialogMode={dialogMode} containerRef={containerRef}>
        {view === 'table' ? (
          <RoundResultTable dialogDatas={dialogDatas} displayMode="top" displayCount={20} />
        ) : (
          renderResult()
        )}
        <div style={{ marginBottom: '10px', padding: '0 16px' }}>
          <button onClick={() => setView('result')} disabled={view === 'result'}>
            ラウンド概要
          </button>
          <button onClick={() => setView('table')} disabled={view === 'table'}>
            全体結果
          </button>
        </div>
      </BaseDialog>
    </div>
  );
};

export default OwnerResultDialog;
